module.exports = __webpack_public_path__ + "img/logo.3f9dc8b1.png";